import { useState } from 'react';
import { useTheme } from '@mui/material';
import {
    CancelScheduleSend as CancelSendIcon,
    Send as SendIcon,
} from '@mui/icons-material';
import Box from '@/components/ui/Box/Box';
import Button from '@/components/ui/Button/Button';
import FieldWrapper from '@/components/ui/FieldWrapper/FieldWrapper';
import TextField from '@/components/ui/TextField/TextField';
import ConfirmDialog from '@/components/business/ConfirmDialog/ConfirmDialog';
import type { InvitationStatusFormProps } from './IInvitationStatusForm';
import { styles } from './styles';

type Action = 'resend' | 'cancel' | null;

const COPY: Record<Exclude<Action, null>, { title: string; message: string; confirm: string }> = {
    resend: {
        title: 'Resend Invite',
        message: 'Do you want to resend this invite?',
        confirm: 'Yes',
    },
    cancel: {
        title: 'Cancel Invite',
        message: 'Do you want to cancel this invite?',
        confirm: 'Yes',
    },
};

const InvitationStatusForm = ({ repairer }: InvitationStatusFormProps) => {
    const theme = useTheme();
    const [action, setAction] = useState<Action>(null);
    const registrationCode = repairer.registration_code ?? repairer.registrationCode ?? '';

    const handleConfirm = () => {
        // TODO: Wire up to repairer invite endpoint once the API supports it
        setAction(null);
    };

    return (
        <>
            <Box sx={styles.fields}>
                <FieldWrapper filled={Boolean(repairer.email)}>
                    <TextField
                        fullWidth
                        label="Email"
                        value={repairer.email ?? ''}
                        helperText="Waiting for activation"
                        disabled
                    />
                </FieldWrapper>
                <FieldWrapper filled={Boolean(registrationCode)}>
                    <TextField
                        fullWidth
                        label="Registration Code"
                        value={registrationCode}
                        disabled
                    />
                </FieldWrapper>
            </Box>
            <Box sx={styles.actions}>
                <Button
                    variant="outlined"
                    sx={styles.cancelBtn(theme)}
                    startIcon={<CancelSendIcon />}
                    onClick={() => setAction('cancel')}
                >
                    Cancel Invite
                </Button>
                <Button
                    variant="outlined"
                    sx={styles.resendBtn(theme)}
                    startIcon={<SendIcon />}
                    onClick={() => setAction('resend')}
                >
                    Resend Invite
                </Button>
            </Box>
            {action && (
                <ConfirmDialog
                    open
                    title={COPY[action].title}
                    message={COPY[action].message}
                    confirmLabel={COPY[action].confirm}
                    cancelLabel="No"
                    danger={action === 'cancel'}
                    onConfirm={handleConfirm}
                    onCancel={() => setAction(null)}
                />
            )}
        </>
    );
};

export default InvitationStatusForm;
